import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import Login from '~/pages/Login';
import MFA from '~/pages/MFA';
import RequireAuth from '~/components/RequireAuth';
import NotFound from '~/components/NotFound';

// Login is statically imported (lives in the main bundle); everything under
// pages/installer/* is lazy-loaded so it ships in the installer-* chunk that
// the edge gate refuses to serve unauthenticated.
// See docs/SECURITY_ADMIN_INSTALLER.md.
const Dashboard = lazy(() => import('~/pages/installer/Dashboard'));
const InstallationDetail = lazy(() => import('~/pages/installer/installation/$installationId'));
const FounderProgram = lazy(() => import('~/pages/installer/founder-program'));

const Lazy = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={<div className="p-6 text-gray-500">Loading…</div>}>{children}</Suspense>
);

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  // /mfa = AAL1→AAL2 gate. See apps/admin/src/routes.tsx for rationale.
  { path: '/mfa', element: <MFA /> },
  { path: '/', element: <Navigate to="/dashboard" replace /> },
  {
    element: <RequireAuth />,
    children: [
      { path: '/dashboard', element: <Lazy><Dashboard /></Lazy> },
      { path: '/installation/:installationId', element: <Lazy><InstallationDetail /></Lazy> },
      { path: '/founder-program', element: <Lazy><FounderProgram /></Lazy> },
    ],
  },
  // Catch-all 404 — see apps/admin/src/routes.tsx for rationale.
  { path: '*', element: <NotFound /> },
]);
